// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../opt/homebrew/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media only screen and (max-width: 575px){\n    .page-wrapper .page-main-header .main-header-right .nav-right .profile-dropdown {\n        left: -125px !important;\n    }\n    \n}\n@media only screen and (max-width: 991px){\n\n.page-wrapper .page-main-header .main-header-right .nav-right .onhover-dropdown .onhover-show-div.profile-dropdown {\n   \n    margin-left: -65px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
